import { createStore } from 'vuex';
import response from './response';
import user from './user';
import page from './page';
import channel from './channel';
import netmanager from './net-manager';
import eorderetails from './pam/eorder-details';
import specialOfferDetails from './pam/special-offer-details';
import specialOffer from './pam/special-offer';
import purchaseRequisition from './pam/purchase-requisition';
import purchaseOrder from './pam/purchaseOrder';
const store = createStore({
    modules: {
        response,
        user,
        page,
        channel,
        netmanager,
        eorderetails,
        specialOfferDetails,
        specialOffer,
        purchaseRequisition,
        purchaseOrder
    }
})


export default store
